var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "multiselect",
    {
      attrs: {
        value: _vm.value,
        options: _vm.nameOptions,
        taggable: true,
        internalSearch: false,
        id: _vm.id,
        placeholder: _vm.placeholder,
        "tag-placeholder": "Als Aufgabe übernehmen",
      },
      on: {
        input: _vm.select,
        tag: _vm.select,
        "search-change": function ($event) {
          _vm.nameSearch = $event
        },
        close: function ($event) {
          return _vm.select(_vm.nameSearch)
        },
      },
    },
    [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }